import { Audio, Images, Tweens } from "@abcya/abcya_phaser";
import gameData from "../gameData";
import GridDisplay from "../items/GridDisplay";
import PatternDisplay from "../items/PatternDisplay";
import SnowLayer from "../items/SnowLayer";
import { centerSprite } from "../phaserHelpers";
import RandomValuePool from "../RandomValuePool";
import SoundAssetKeys from "../SoundAssetKeys";
import Hud from "../ui/Hud";
import UIAssetKeys from "../UIAssetKeys";
import ResultsScene from "./ResultsScene";

export default class GameplayScene extends Phaser.Scene
{
    static get KEY() { return 'GameplayScene'; }

    create()
    {

        this.showCheatDot = false;
        this.useFollowMouse = this.game.device.os.desktop;//true;

        // gamevars
        this.totalScore = 0;
        this.timesUp = false;
        this.turnTime = this.level1turnTime = 30;
        this.timeLeft = this.turnTime;
        this.maxMatchPoints = 225;
        this.nextLevelCount = 10;

        this.add.tween({
            targets: this.sound.title,
            duration: 800,
            volume: .25
        })

        this.newLevelSound = SoundAssetKeys._Sound_2__Deck_the_Halls__Christmas_WS;
        this.wrongSound = SoundAssetKeys._glass_07;
        this.correctSound = SoundAssetKeys._Pop_Sparkle_01;

        this.timesupSound = SoundAssetKeys._Ho_Ho_Ho;

        this.curLevel = 1;

        this.correctCount = 0;
        this.totalCorrectCount = 0;
        this.tileLevelIndex = 0;
        this.nextTileLevelCounts = [10, 20, 30, 40, 50, 60, 70];
        this.nextTileCount = this.nextTileLevelCounts[this.tileLevelIndex];

        this.selectorDisabled = 0;// > 0 is in time that is should be disabled
        this.selectorTop = 23;// account for handle of ornament

        this.sceneState = 0;

        // scene sprites
        this.bg = this.add.sprite(0,0, gameData.ss, "Background").setOrigin(0);
        this.snowGroup = this.add.group();

        const snow = new SnowLayer(this, 0, 0);
        this.add.existing(snow);

        this.hud = new Hud(this, gameData.ss);
        this.hud.x = (this.scale.width-this.hud.getBounds().width)/2;
        this.hud.y = 18;
        this.add.existing(this.hud);

        this.snowBank = this.add.sprite(0,0,gameData.ss, "FrontSnowbank").setOrigin(0);
        this.snowBank.y = this.scale.height-this.snowBank.height;

        this.gridDisplay = new GridDisplay(this, this.game, gameData.ss, 26, 270);
        this.add.existing(this.gridDisplay);

        this.tileParticleGroup = this.add.group();

        this.selector = this.add.sprite(0,0,gameData.ss, "OrnamentSelector");
        this.selector.setOrigin(0.5);

        this.selectorIntroTween = Tweens.addTween(this.selector, 440, {scaleX: 1, scaleY: 1, paused: true, easeParams:[1, 0.3]}, Phaser.Math.Easing.Elastic.Out);

        if (this.showCheatDot===true) this.cheatSprite = this.add.sprite(0,0,gameData.ss, "test");

        let y = this.hud.y+this.hud.getBounds().height+13;
        let x = (this.scale.width-this.selector.width)/2;
        this.patternDisplay = new PatternDisplay(this, this.game, x, y, gameData.ss, this.selectorTop);
        this.add.existing(this.patternDisplay);

        this.patternUserDisplay = new PatternDisplay(this, this.game, 0, 0, gameData.ss, this.selectorTop);
        this.add.existing(this.patternUserDisplay);
        this.patternUserDisplay.visible = false;

        this.instructions = this.add.sprite(60,144,gameData.ss, "Instruct").setOrigin(0);
        this.instructions.isShowing = true;

        this.initParticles();

        this.txtCenterMessage = this.add.bitmapText(this.scale.width/2, 400, 'greenstripeFont', 'Get Ready!', 92);
        centerSprite(this.txtCenterMessage);

        this.scoreUps = this.add.container();
        let cnt = 4;
        for (let i=0;i<cnt;i++)
        {
            const item = this.add.bitmapText(0,0, 'greenstripeFont', "+200", 48, this.scoreUps);
            this.scoreUps.add(item);
            item.setOrigin(.5, 0);
            item.visible = false;
            //item.kill();
        }

        this.brokenOrnaments = this.add.container();
        for (let i=0;i<4;i++)
        {
            const item = Images.addImage(0,0,"OrnamentSelector_Broken_2a", this.brokenOrnaments).setOrigin(0);
            item.visible = false;
        }

        cnt = 0;
        cnt = this.gridDisplay.maxRowStarter;
        let values = [];
        for (let i=0;i<cnt;i++)
        {
            values.push(i);
        }
        
        this.rowPool = new RandomValuePool(values);

        values = [];
        cnt = this.gridDisplay.maxColStarter;
        for (let i=0;i<cnt;i++)
        {
            values.push(i);
        }
        this.colPool = new RandomValuePool(values);

        this.curPattern = [[0,0],[0,0]];//[[typeId,typeId],[typeId,typeId]]
        this.selectedPattern = [[0,0],[0,0]];//[[typeId,typeId],[typeId,typeId]]

        this.gridDisplay.initializeGridForLevel(this.tileLevelIndex+1);
        this.startupLevel(this.curLevel);

        const tween = Tweens.addTween(this.txtCenterMessage, 800, {x:{start:this.scale.width+this.txtCenterMessage.width, to: this.x}}, Phaser.Math.Easing.Elastic.Out, ()=>this.getReady());

        if (this.useFollowMouse) {
            this.moveCallback = this.input.on('pointermove', this.handleMouseMove, this);
            this.selector.setInteractive();
            this.selector.on('pointerup', (pointer)=>this.handleMouseClick(this.selector, pointer));
            this.selector.x = -223;
        }else{

            this.selector.setInteractive({ draggable: true, useHandCursor: true });
            this.selector.input.boundsRect = this.gridDisplay.getTilesRect();

            this.selector.on('drag', (pointer, dx, dy)=>{
                
                if(dx > 630) this.selector.x = 630;
                else if(dx < 126) this.selector.x = 126;
                else this.selector.x = Phaser.Math.Snap.To(dx, this.gridDisplay.tileSize) - 17;

                if(dy > 860) this.selector.y = 860;
                else if(dy < 356) this.selector.y = 356;
                else this.selector.y = Phaser.Math.Snap.To(dy, this.gridDisplay.tileSize) - 4;

            })
            this.selector.on('dragstart', this.hideInstructions, this);
            this.selector.on('dragend', ()=>this.checkSelection(this.selector));
        }

        this.resetSelectorPosition();
        this.selector.scaleX = 0;
        this.selector.scaleY = 0;
        this.selectorIntroTween.play();
        this.selectorDisabled = 0;
    }

    getReady() {
        const tween = Tweens.addTween(this.txtCenterMessage, 1000, {alpha:1, easeParams: [1, 0.3]}, Phaser.Math.Easing.Elastic.In, ()=>this.beginNewLevel());
    };

    beginNewLevel() {
        this.txtCenterMessage.text = "GO!";
        this.txtCenterMessage.x = this.scale.width/2;
        this.selectorDisabled = 0;
        this.resetSelectorPosition();
        const tween = Tweens.addTween(this.txtCenterMessage, 720, {x:-this.txtCenterMessage.width, easeParams: [1, 0.3]}, Phaser.Math.Easing.Elastic.In);
        this.hud.updateCount(this.correctCount, this.nextLevelCount);
        this.sceneState = 2;
    };

    initParticles() {
        const particles = this.add.particles(Images.DEFAULT_ATLAS, UIAssetKeys._Sparkle1);

        this.winParticles = particles.createEmitter({
            frame: [UIAssetKeys._Sparkle1, UIAssetKeys._Glow1],
            lifespan: 1300,
            //maxParticles: 50,
            frequency: 1000,
            quantity: {min: 5, max: 10},
            speedY: {min: -150, max: 100},
            speedX: {min: -100, max: 100},
            //speed: {min: 20, max: 100},
            radial: true,
            //gravityY: 100,
            rotate: {start: 0, end: 180},
            angle: {min: 0, max: 180},
            alpha: {start: 1, end: .4},
            y: 10,
            gravity: 0,
            x: 100,
            on: false,
            emitCallback: (particle, emitter)=>{
                emitter.rotate.end = Phaser.Math.RND.angle();
            }
        });

        const loseConfig = {
            frame: [UIAssetKeys._TileColorDot_001],
            lifespan: 1300,
            //maxParticles: 50,
            frequency: 1000,
            quantity: 68,
            speedY: {min: 0, max: 10},
            //speedX: {min: -100, max: 100},
            //speed: {min: 20, max: 100},
            radial: true,
            gravityY: 1000,
            rotate: {start: 0, end: 180},
            angle: {min: 0, max: 180},
            alpha: {start: 1, end: .4},
            y: {min:0, max:75},
            x: {min:0, max:75},
            on: false,
            emitCallback: (particle, emitter)=>{
                //this.loseParticles.stop()
                emitter.stop();
            }
        }

        this.loseParticlesTL = particles.createEmitter(loseConfig);

        this.loseParticlesTR = particles.createEmitter(loseConfig);

        this.loseParticlesBL = particles.createEmitter(loseConfig);

        this.loseParticlesBR = particles.createEmitter(loseConfig);

    };

    startupLevel(level) {
        this.curLevel = level;
        this.correctCount = 0;
        this.selectPatternFromGrid();
    };

    selectPatternFromGrid() {

        const row = this.rowPool.getValue();
        const col = this.colPool.getValue();
        if (this.cheatSprite) {
            var pt = this.gridDisplay.getTilePosition(row, col);
            this.cheatSprite.x = pt.x;
            this.cheatSprite.y = pt.y;
        }
        this.gridDisplay.getPatternFromStarterTile(row, col, this.curPattern);
        this.patternDisplay.setPattern(this.curPattern);
    };

    resetSelectorPosition() {
        if (!this.useFollowMouse) {
            this.selector.x = 630;
            this.selector.y = this.patternDisplay.y+this.selector.height/2;
        }

        //this.selectorIntroTween.stop();
        this.selector.alpha = 1;
    };

    handleMouseMove(pointer, x, y, clicked) {
        const pos = this.gridDisplay.getTileLocationFromMousePoint(pointer.x, pointer.y);
        if (pos) {
            this.selector.x = pos.x+this.selector.width*0.25;
            this.selector.y = pos.y+this.selector.width*0.25-this.selectorTop/2;
        }
    };

    handleMouseClick(sprite, pointer) {
        this.hideInstructions();
        this.checkSelection(sprite, pointer);
    };

    hideInstructions() {
        if (this.instructions) {
            this.instructions.destroy();
            this.instructions = null;
        }
    };

    checkSelection(sprite, pointer) {
        if (this.selectorDisabled > 0 || this.timesUp) return;
        if (this.hud.isPaused) {
            this.resetSelectorPosition();
            return;
        }
        let x = sprite.x;
        let y = sprite.y+this.selectorTop;
        let px = sprite.x+sprite.width/2;
        let py = sprite.y;
        let rc = this.gridDisplay.getTileRowColFromPoint(x-sprite.width/2, y-sprite.height/2);

        let isCorrect = false;
        if (rc && rc[0]>=0 && rc[1]>=0) {
            this.gridDisplay.getPatternFromStarterTile(rc[0], rc[1], this.selectedPattern);
            isCorrect = this.checkSelectedPattern();
        }

        if (isCorrect) {
            //BOP.audio.playSound(this.correctSound);
            Audio.playOneShot(this.correctSound, this);
            this.correctCount++;

            this.showCorrect(sprite, px, py);

            this.winParticles.emitParticle(28, sprite.x, sprite.y);

            this.timeLeft = this.turnTime;
            this.gridDisplay.setNewPatternFromStarterTileWidthTransition(rc[0], rc[1]);

            this.selectPatternFromGrid();
            this.resetSelectorPosition();

            this.totalCorrectCount++;
            if (this.totalCorrectCount >= this.nextTileCount) {
                this.tileLevelIndex++;
                this.gridDisplay.newMaxTileType(this.tileLevelIndex+1);
                if (this.tileLevelIndex <= this.nextTileLevelCounts.length-1){
                    this.nextTileCount = this.nextTileLevelCounts[this.tileLevelIndex];
                }else{
                    this.nextTileLevelCounts = 2500;
                }
            }

            if (this.correctCount >= this.nextLevelCount) {
                this.doLevelUp();
            }

        }else{

            Audio.playOneShot(this.wrongSound, this);
            this.showIncorrect(rc, sprite, px, py);
            this.selector.alpha = 0;
            this.selectorDisabled = 0.8;
            this.selectorNeedReset = true;
        }
    };

    checkSelectedPattern() {
        return (
            this.selectedPattern[0][0] === this.curPattern[0][0] &&
            this.selectedPattern[1][0] === this.curPattern[1][0] &&
            this.selectedPattern[0][1] === this.curPattern[0][1] &&
            this.selectedPattern[1][1] === this.curPattern[1][1]
        );
    };

    showCorrect(sprite, px, py) {

        this.patternUserDisplay.setPattern(this.selectedPattern);
        this.patternUserDisplay.x = sprite.x-sprite.width/2;
        this.patternUserDisplay.y =  sprite.y-sprite.width/2-this.selectorTop/2;
        this.patternUserDisplay.visible = true;
        this.patternUserDisplay.scaleX = 1;
        this.patternUserDisplay.scaleY = 1;
        this.patternUserDisplay.updateMaskPos();

        Tweens.addTween(this.patternUserDisplay, 480, {scaleX: 0.1, scaleY: 0.1, delay: 320}, Phaser.Math.Easing.Quadratic.Out);
        let tween = Tweens.addTween(this.patternUserDisplay, 800, {x: 292, y: 36}, Phaser.Math.Easing.Quadratic.Out);
        tween.on('update', ()=>this.patternUserDisplay.updateMaskPos());
        tween.on('complete', ()=>this.resetPatterUserDisplay());

        const sup = this.scoreUps.getRandom();
        sup.visible = true;
        const points = ~~(this.maxMatchPoints*(this.timeLeft / this.turnTime));
        this.totalScore += points;

        this.hud.updateScore(this.totalScore);
        this.hud.updateCount(this.correctCount, this.nextLevelCount);

        sup.text = "+" + points;
        //sup.reset(px, py);
        sup.setPosition(px, py + 50)
        sup.alpha = 1;
        tween = Tweens.addTween(sup, 900, {y:py-180}, Phaser.Math.Easing.Quadratic.Out,()=>tween2.play());
        const tween2 = Tweens.addTween(sup, 320, {y:py-200, alpha:0, paused: true}, Phaser.Math.Easing.Quadratic.InOut, ()=>{sup.visible = false;});
    };

    doLevelUp() {
        Audio.playOneShot(this.newLevelSound, this);
        this.nextLevelCount += 5;
        this.selectorDisabled = 10;
        this.selector.alpha = 0;
        this.sceneState = 1;
        this.curLevel++;
        this.correctCount = 0;
        this.txtCenterMessage.text = "Level " + this.curLevel;
        this.txtCenterMessage.x = this.scale.width/2;
        this.turnTime = this.level1turnTime - (5*(this.curLevel-1));
        if (this.turnTime < 3) this.turnTime = 3;
        this.timeLeft = this.turnTime;
        this.hud.updateTimer(this.timeLeft, this.turnTime);
        this.hud.updateLevel(this.curLevel);
        const tween = Tweens.addTween(this.txtCenterMessage, 800, {x:{start:this.scale.width+this.txtCenterMessage.width, to: this.txtCenterMessage.x}, easeParams:[1, 0.3]}, Phaser.Math.Easing.Elastic.Out,()=>this.getLevelReady());
    };

    getLevelReady() {
        const tween = Tweens.addTween(this.txtCenterMessage, 1000, {alpha:1}, null, ()=>this.beginNewLevel());
    };

    showIncorrect(rc, sprite, px, py) {
        const fallingOne = this.brokenOrnaments.getRandom();
        fallingOne.visible = true;
        if (fallingOne) {
            fallingOne.setPosition(sprite.x-sprite.width/2, sprite.y-sprite.height/2);
            fallingOne.alpha = 1;
            const fallTween = Tweens.addTween(fallingOne, 800, {y:this.scale.height+fallingOne.height}, Phaser.Math.Easing.Quadratic.In, ()=>{
                fallingOne.visible = false;
            });
        }
        const ok = this.gridDisplay.selectedWrongTiles(rc[0], rc[1]);
        if (ok) {
            //this.tileEmitter.force.y = 0.5;
            px += -(sprite.width/2);
            py += -(sprite.height/2);
            this.doTileParticles(px-sprite.width/2, py-sprite.height/2, this.selectedPattern[0][0], this.loseParticlesTL);
            this.doTileParticles(px, py-sprite.height/2, this.selectedPattern[0][1], this.loseParticlesTR);
            this.doTileParticles(px-sprite.width/2, py, this.selectedPattern[1][0], this.loseParticlesBL);
            this.doTileParticles(px, py, this.selectedPattern[1][1], this.loseParticlesBR);
        }
    };

    doTileParticles(x,y,type,emitter) {
        let t = type;
        if (type > 5) {
            t = type % 5;
            if (t<=0) t = 5;
        }

        const f = "TileColorDot_00"+t;

        y += 108;

        emitter.setPosition({min: x+5, max: x + 70}, {min: y, max: y + 60});
        emitter.setFrame(f);

        emitter.start();
    };

    resetPatterUserDisplay() {
        this.patternUserDisplay.resetDisplay();
        this.patternUserDisplay.visible = false;
    };

    update(time, delta) {
        if (this.timesUp === true || this.hud.isPaused === true) return;
        if (this.sceneState < 2) return;
        this.timeLeft -= (delta / 1000);

        if (this.timeLeft <= 0) {
            this.doGameOver();
            return;
        }
        this.hud.updateTimer(this.turnTime,this.timeLeft);

        if (this.selectorNeedReset && this.selectorDisabled <= 0) {
            this.resetSelectorPosition();
            this.selectorNeedReset = false;
        }else{
            if (this.selectorDisabled > 0) {
                this.selectorDisabled -= delta / 1000;
            }
        }
    };

    doGameOver() {
        this.add.tween({
            targets: this.sound.title,
            duration: 800,
            volume: 1
        })
        this.timesUp = true;
        this.timeLeft = 0;
        this.hideInstructions();
        this.selector.destroy();
        this.txtCenterMessage.text = "Game Over";
        this.txtCenterMessage.x = this.scale.width/2;
        Audio.playOneShot(this.timesupSound, this)
        let tween = Tweens.addTween(this.txtCenterMessage, 800, {x:{start:this.scale.width+this.txtCenterMessage.width, to: this.txtCenterMessage.x}, easeParams: [1, 0.3]}, Phaser.Math.Easing.Elastic.Out);
        tween = Tweens.addTween(this.patternDisplay, 2200, {alpha:0}, Phaser.Math.Easing.Quadratic.Out);
        tween = Tweens.addTween(this.hud, 200, {alpha:0}, Phaser.Math.Easing.Quadratic.Out);
        tween = Tweens.addTween(this.gridDisplay, 2200, {alpha:0}, Phaser.Math.Easing.Quadratic.Out, ()=>{this.nextScene()});
    };

    nextScene() {
        gameData.score = this.totalScore;
        gameData.level = this.curLevel;
        gameData.totalMade = this.totalCorrectCount;
        gameData.tileLevel = this.gridDisplay.maxTileTypeId;
        this.scene.start(ResultsScene.KEY);
    };
}


    // me.shutdown = function() {
    //     if (this.moveCallback) {
    //         this.game.input.removeMoveCallback(this.moveCallback);
    //         this.moveCallback = null;
    //     }
    //     this.selector.destroy();
    //     this.hud.housekeeping();
    // };
